import { ShieldCheck } from "lucide-react";
import usamaPhoto from "@/assets/usama-ali.webp";

interface ReviewedByPillProps {
  date?: string;
  className?: string;
}

const ReviewedByPill = ({ date = "April 2026", className = "" }: ReviewedByPillProps) => (
  <div
    className={`inline-flex items-center gap-2 sm:gap-2.5 bg-card rounded-full pl-1 pr-3 sm:pr-4 py-1 shadow-sm border border-border/60 ${className}`}
  >
    <img
      src={usamaPhoto}
      alt="Usama Ali, Pharmacist"
      className="w-7 h-7 sm:w-8 sm:h-8 rounded-full object-cover object-top ring-1 ring-primary/20 shrink-0"
      width={32}
      height={32}
    />
    <div className="flex flex-col text-[11px] sm:text-xs">
      <div className="flex items-center gap-1 sm:gap-1.5">
        <ShieldCheck className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-primary shrink-0" />
        <span className="text-foreground/70">
          <a href="/authors/usama-ali/" className="font-semibold text-foreground hover:text-primary hover:underline">Reviewed by Usama Ali</a>
          <span className="hidden xs:inline">, Pharmacist</span>
          {" · "}
          <a
            href="https://www.pharmacyregulation.org/registers/pharmacist/2224726"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            GPhC: 2224726
          </a>
        </span>
      </div>
      {date && (
        <span className="text-foreground/50 pl-4 sm:pl-5 mt-0.5">Last reviewed: {date}</span>
      )}
    </div>
  </div>
);

export default ReviewedByPill;
